export default theme => ({
  footer: {
    minHeight: 56,
    display: "table",
    width: "100%",
  },
  footer_content: {
    display: "table-cell",
    textAlign: "center",
    verticalAlign: "middle",
  },
});
